import * as React from 'react';
import './Tab.scss';

export interface IProps {
    title: string;
    isActive: boolean;
}

export interface IFunctions {
    onClick: () => void;
}

export type IAllProps = IProps & IFunctions;

export const Tab: React.SFC<IAllProps> = ({ title, isActive, onClick }) =>
    <li className={`Tab-wrap ${isActive && 'active-tab'}`} onClick={onClick}>
        {title}
    </li>;

export default Tab;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/tabs/tab/Tab.tsx